import React from 'react';

import {TransportContainerCard} from 'components/ais/transport-container-card';
import {Table} from 'components/table';
import {ITableScroll} from 'components/table/table';
import {EEntityType} from 'shared/constants/entities';

export interface IFileSharingCardProps {
    url: string;
    hideTitle?: boolean;
    entityType?: EEntityType;
    entityName: string;
    scroll?: ITableScroll;
    entity: string | null;
}

export const FileSharingCard = ({
    entity: id, scroll, url, hideTitle, entityType, entityName,
}: IFileSharingCardProps) => (
    <>
        <Table
            hideTitle={hideTitle}
            entityName={entityName}
            url={url}
            entityType={entityType}
            scroll={scroll}
        />
        {id && (
            <TransportContainerCard
                id={id}
                entityName={entityName}
            />
        )}
    </>
);
